import { API } from "aws-amplify";

export default async function getBankLetter(accountNumber) {
  if (accountNumber) {
    return await API.get("bankLetter", `${accountNumber}`, {
      responseType: "blob",
    });
  }
}
